// https://github.com/simple-uploader/Uploader#configuration
export interface UploaderInstance {
  upload: () => void
  cancel: () => void
}

export interface UploaderFile {
  id: number
  name: string
  fileType: string
  size: number
  file: File
  resume: () => void
  cancel: () => void
  retry: () => void
  getExtension: () => string
}

// 当前 UI 中文件状态
export enum FileStatus {
  waiting,
  offlineCheckSuccess,
  offlineCheckFail,
  onlineCheckSuccess,
  onlineCheckFail,
  uploading,
  uploadSuccess,
  uploadError,
  Error,
}

export enum UploadStatus {
  waiting,
  uploading,
  uploadEnd,
}

// 文件的额外属性，为了实现弹框中的功能，扩展的 file 能力
export interface FileExtraProp {
  id: number
  selected: boolean
  status: FileStatus
  errorMsg: string
  size: number
  name: string
  file_url: string // 上传返回的私有地址
  progress: number // 上传进度 0-100
  md5: string // 计算的 md5 值，如果没有计算出来，不允许上传
}

export interface UploaderState {
  uploaderInstance: null | UploaderInstance
  uploadStatus: UploadStatus
  dialogVisible: boolean
  fileList: UploaderFile[]
  fileExtraList: FileExtraProp[]
  freeSize: number // 剩余空间， -1 代表不限制
  totalSize: number // 全局空间， -1 代表不限制
  usedSize: number // 已用空间
  totalAssets: number // 资产库总资源
}
